import './PanelNavbar.css'
import React, { useState } from 'react'
import { RiMenu2Line } from '@react-icons/all-files/ri/RiMenu2Line.esm'
import { CgClose } from '@react-icons/all-files/cg/CgClose.esm';
import { Button } from '../../../components/Button';
import { IconLogout } from '../../../BTUI/Icons';
import authService from '../../../service/auth';
import { toastSuccess } from '../../../BTUI/BtToast';
import { useNavigate } from 'react-router-dom';
import { Popup } from '../../../components/Form';


function PanelNavbar(props) {
    const [trigger, setTrigger] = useState(false)
    const navigate = useNavigate()
    const handleLogout = ()=>{
        authService?.logout()
            .then((res) =>{
                console.log(res)
                toastSuccess(res?.data?.message)
                navigate('/login')
            })
            .catch((err)=>{
                console.log(err);
            })
    }

    return (
        <div className='panelNavbarSection'
            style={{
                left: props?.headerLeft,
                width: props?.headerWidth          
            }}
        >
            <div className='panelNavbarLogoDiv'>
                <Button
                    variant="transparent-btn" 
                    onClick={props.onClick} 
                    varient="icon"
                    color='white'
                    title={props.isToggle ? <CgClose /> : <RiMenu2Line />} 
                    style={{
                        fontSize:'1.5em'
                    }}    
                />
            </div>
            <div className='panelNavbarContent'>
                <ul className=''>
                    <li style={{color: 'white', fontSize: '1.5em'}}><IconLogout onClick={()=>setTrigger((prev)=>!prev)}/></li>
                </ul>
            </div>
            <Popup 
                maxWidth="30em"
                trigger={trigger}
                setTrigger={()=>setTrigger((prev)=>!prev)}
            >
                Are you sure, you want to logout?
                <br/>
                <br/>
                <div className="" style={{display: 'flex', gap: '1em'}}>
                    <Button varient="action-btn primary" title="Logout" onClick={handleLogout}/>
                    <Button varient="action-btn sec" title="Cancel" onClick={()=>{setTrigger((prev)=>!prev)}}/>
                </div>
                
            </Popup>
        </div>
    )
}

export default PanelNavbar


// const PopupLogout = ({trigger, setTrigger}) => {

//     return
// }